import { LocalStorage } from './localStorage/LocalStorage'

export const autorizaçãoHeader = () => {
  return {
    authorization: `Bearer ${new LocalStorage().get('@Esforce:Auth-Token')}`,
  }
}
